import { render } from "./PrivacyPolicyV2.vue?vue&type=template&id=fd350ad6&scoped=true"
const script = {}

import "./PrivacyPolicyV2.vue?vue&type=style&index=0&id=fd350ad6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd350ad6"]])

export default __exports__